import Vue from 'vue';
import store from '../store';

export const getLabelFromDic = (dicList, lang, type, value) => {
  let label = '';

  for (let i = 0; i < dicList.length; i++) {
    let dic = dicList[i];
    if (dic.type === type) {
      const valueList = dic.valueList;
      for (let j = 0; j < valueList.length; j++) {
        const valueLabel = valueList[j];
        if (valueLabel.value + '' === value + '') {
          label = valueLabel[lang];
          if (!label && lang === 'zh_CN') {
            label = valueLabel['zh'];
          }

          if (!label) {
            label = valueLabel['en'];
          }
          break;
        }
      }
    }
  }
  return label;
};

// 定义一个 Vue 全局的过滤器，用来解析字典
Vue.filter('dic', function (value, type) {
  // 字符串的  replace 方法，第一个参数，除了可写一个 字符串之外，还可以定义一个正则
  const lang = store.getters.language;
  const dicList = store.getters.dicList;

  return getLabelFromDic(dicList, lang, type, value)
});



// WEBPACK FOOTER //
// ./src/utils/sysdic.js